import { Injectable } from "@angular/core";
import * as colors from "tailwindcss/colors";
import { setThemeColor } from "../utils/theme";
import { default as palette } from "@apps/patient-core/palette";
import { getContrastColour, isLightColor, lighten, darken } from "@shared/colours";

// { sm: '640px', md: '768px', lg: '1024px', xl: '1280px' }

type Palette = {
  name: string;
  colors: {
    [key: number]: string;
  };
};

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private _setupPrimaryPalette(baseColor: string, colorName: string) {
    const response: Palette = {
      name: colorName,
      colors: {
        500: `#${baseColor}`.replace("##", "#"),
      },
    };

    const intensityMap: {
      [key: number]: number;
    } = {
      50: 0.95,
      100: 0.9,
      150: 0.85,
      200: 0.75,
      250: 0.7,
      300: 0.6,
      350: 0.5,
      400: 0.3,
      450: 0.2,
      600: 0.9,
      650: 0.85,
      700: 0.75,
      750: 0.7,
      800: 0.6,
      850: 0.5,
      900: 0.49,
    };

    [50, 100, 150, 200, 250, 300, 350, 400, 450].forEach((level) => {
      response.colors[level] = lighten(baseColor, intensityMap[level]);
    });

    [600, 650, 700, 750, 800, 850, 900].forEach((level) => {
      response.colors[level] = darken(baseColor, intensityMap[level]);
    });

    return response;
  }

  private _setHexColour = "";

  public setup(hexcolor: string) {
    if (hexcolor === this._setHexColour) return;

    this._setHexColour = hexcolor;

    const primaryPalette = this._setupPrimaryPalette(hexcolor, "primary-shade");
    const pinePalette = palette.pine;
    for (const key in primaryPalette.colors) {
      document.body.style.setProperty(`--${primaryPalette.name}-${key}`, primaryPalette.colors[key]);
    }
    for (const [key, value] of Object.entries(pinePalette)) {
      document.body.style.setProperty(`--pine-${key}`, String(value));
    }

    document.body.style.setProperty(`--primary`, hexcolor);
    document.body.style.setProperty(`--primaryContrast`, getContrastColour(hexcolor));
    document.body.style.setProperty(`--primaryText`, isLightColor(hexcolor) ? colors.gray[700] : hexcolor);
    setThemeColor(hexcolor);
  }
}
